import React from 'react'
import "../assets/css/howWeWorks.css"
import { LuMoveRight } from 'react-icons/lu'

function HowWeWorks() {
    return (
        <>
            <section className="how-we-work">
                <div className="how-we-work__header">
                    <span className="how-we-work__tag">HOW WE WORK</span>
                    <h2>Simple, Transparent &amp; Reliable</h2>
                </div>

                <div className="how-we-work__steps">
                    {/* Step 1 */}
                    <div className="step">
                        <div className="step__icon">
                            <img src={require('../assets/images/work-flow/order-delivery.png')} alt="Share Requirement" />
                        </div>
                        <h3>Share Your Requirement</h3>
                        <p>
                            Tell us the type of resin you need (UF, MF, MUF, PF, Fish
                            Feed Binder) and your technical specifications.
                        </p>
                    </div>

                    <div className="step__arrow"><LuMoveRight /></div>

                    {/* Step 2 */}
                    <div className="step">
                        <div className="step__icon">
                            <img src={require('../assets/images/work-flow/factory.png')} alt="Manufacturing" />
                        </div>
                        <h3>Manufacturing With Precision</h3>
                        <p>
                            Our experienced manufacturing team ensures consistent
                            quality and precise production.
                        </p>
                    </div>

                    <div className="step__arrow"><LuMoveRight style={{fontWeight:'500'}} /></div>

                    {/* Step 3 */}
                    <div className="step">
                        <div className="step__icon">
                            <img src={require('../assets/images/work-flow/delivery-man.png')} alt="Delivery" />
                        </div>
                        <h3>On-Time Delivery &amp; Support</h3>
                        <p>
                            Sit back and enjoy reliable delivery with complete
                            post-delivery support.
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HowWeWorks